import { useEffect, useState } from 'react';
import { useUserContextApi } from '../../../shared/context/UserContext';
import useGridColumnAccess from '../../../shared/utils/useGridColumnAccess';
import { useColumnContextAPI } from '../../../shared/context/GetAllColumnContext';
import { useLanguageContextAPI } from '../../../shared/context/LanguageContext';
import { getHeaderName } from '../../../shared/components/grid/SetColumnConfig';
import Spinners from '../../../shared/components/Spinner';
import { Banner } from '@airbus/components-react';
import { t } from '../../../i18next';
import PartSearchForm from './PartSearchForm';
import PartSearchDropdown from './PartSearchDropdown';
import styles from './PartSearchContainer.module.css';

export default function PartSearchContainer({ tableRes }) {
  const [htz, setHtz] = useState(null);
  const { userDetails } = useUserContextApi();
  const { roleId } = userDetails;

  const { isColumnConfigLoading, isError } = useGridColumnAccess({
    tableRes,
    roleIds: [roleId],
  });

  const { allColumns, allAccessibleColumns, setStateAllAccessibleColumnData, tableDetails } =
    useColumnContextAPI();
  const queryColumns = allAccessibleColumns?.map((column) => column.attrInternalName);
  const { language } = useLanguageContextAPI();

  useEffect(() => {
    if (!allColumns) {
      return;
    }

    const columnsWithLabel = allColumns?.map((column) => {
      const { headerName, label } = getHeaderName(column, column.mandatory_column, language);
      return { ...column, headerName, label };
    });
    setStateAllAccessibleColumnData(columnsWithLabel);
  }, [allColumns, language]);

  if (isColumnConfigLoading || !allAccessibleColumns) {
    return <Spinners />;
  }

  if (isError) {
    return <Banner variant='warning'>{t('data_not_available')}</Banner>;
  }

  return (
    <section className={styles.section}>
      <PartSearchDropdown
        setSearchValue={(value) => setHtz(value)}
        screenGridId={tableDetails.id}
      />
      <div className={styles.formWrapper}>
        <PartSearchForm htz={htz} queryColumns={queryColumns} screenGridId={tableDetails.id} />
      </div>
    </section>
  );
}
